import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {fetchList} from '@/api/cs/consumer';
import {wait} from '@/utils/wait';

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		list: []
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'cs.consumer.list', async function () {
				const {searchForm} = state
				let params = {
					loginType: searchForm.loginType
				}
				params[searchForm.select] = searchForm.value
				if (searchForm.timeValue && searchForm.timeValue) {
					params[searchForm.timeSelect] = {
						start: parseInt(searchForm.timeValue[0] / 1000),
						end: parseInt(searchForm.timeValue[1] / 1000)

					}
				}
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...params,
						...payload
					}
				});
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/cs/consumer/list.js